import React from "react";
import { StyledSection, ParrentError, StyledLink } from "../styledErrorPage";
import errorPageImage from "../../../../image/errorPageImage.png";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.log(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <StyledSection className="container text-center">
        <ParrentError>
          <img
            src={errorPageImage}
            alt="404 error"
            width="642"
            className="img-fluid"
          />
          <h3 style={{paddingTop: '30px'}}>لطفا کمی صبر کنید</h3>
          <h2>درصورت عدم تغییر صفحه به پشتیبان سامانه اطلاع دهید</h2>
        </ParrentError>
      </StyledSection>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
